export default {
    props: {
        errors: {
            type: Array,
            default() {
                return [];
            },
        },
        required: {
            type: Boolean,
            default: false,
        },
        tooltip: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: '',
            required: false,
        },
        name: {
            type: String,
            default: '',
            required: false,
        },
    },
};